<template>
    <v-snackbar
        v-model="snackbar.show"
        :bottom="snackbar.y === 'bottom'"
        :left="snackbar.x === 'left'"
        :multi-line="snackbar.mode === 'multi-line'"
        :right="snackbar.x === 'right'"
        :timeout="snackbar.timeout"
        :top="snackbar.y === 'top'"
        :color="snackbar.color"
        :vertical="snackbar.mode === 'vertical'"
        :content-class="snackbar.contentClass"
        rounded="pill"
        id="snackbar"
        :class="snackbar.class"
    >
        <span v-html="snackbar.text"></span>
        <span v-if="showAIColourExtractDownloadProgress" class="ml-3">{{ AIColourExtractDownloadProgress }}%</span>
        <span v-if="showAIAutoCorrectDownloadProgress" class="ml-3">{{ 55 }}%</span>

        <template v-slot:action="{ attrs }">
            <v-btn
                v-if="snackbar.buttonText"
                :color="snackbar.color ? 'white' : 'info'"
                text
                v-html="snackbar.buttonText"
                @click="snackbar.clickHandler"
            />

            <i class="material-icons" @click="snackbar.clickHandler">close</i>
            <!-- <v-btn text :color="snackbar.color ? 'white' : 'info'" @click="snackbar.show = false">
            </v-btn> -->
        </template>
    </v-snackbar>
</template>

<script>
export default {
    data() {
        return {
            snackbar: {
                show: false,
                clickHandler: () => {},
            },
            showAIColourExtractDownloadProgress: false,
            showAIAutoCorrectDownloadProgress: false
        };
    },

    created() {
        this.$eventBus.$on("show-snackbar", (text, type = null, options = {}) => {
            this.showAIColourExtractDownloadProgress = options.showAIColourExtractDownloadProgress;
            this.showAIAutoCorrectDownloadProgress = options.showAIAutoCorrectDownloadProgress;
            this.show(text, type, options);
        });
    },

    computed: {
        AIColourExtractDownloadProgress() {
            return this.$store.state.UI.AIColourExtract.downloadProgress;
        },
        AIAutoCorrectDownloadProgress() {
            return this.$store.state.UI.AIAutoCorrect.downloadProgress;
        },
    },

    methods: {
        show(text, type, options = {}) {
            let delay = this.snackbar.show ? 500 : 0;
            this.snackbar.show = false;

            setTimeout(() => {
                this.snackbar.x = options.x ? options.x : "center";
                this.snackbar.y = options.y ? options.y : "top";
                this.snackbar.mode = options.mode ? options.mode : "";
                this.snackbar.timeout = options.timeout || options.timeout == 0 ? options.timeout : 6000;
                this.snackbar.color = type;
                this.snackbar.text = text;
                this.snackbar.show = true;
                this.snackbar.buttonText = options.buttonText;
                this.snackbar.contentClass = options.contentClass ? options.contentClass : "";
                this.snackbar.class = options.class ? options.class : "";
                this.snackbar.clickHandler = options.clickHandler
                    ? () => {
                        options.clickHandler();
                        this.snackbar.show = false;
                    }
                    : () => (this.snackbar.show = false);
            }, delay);
        },
    },
};
</script>

<style lang="scss" scoped>
.wrapper {
    width: 60px;
    height: 60px;
    border-spacing: 0 !important;
    border-collapse: collapse !important;

    .cell {
        cursor: pointer;
        border: 1px solid #8a94a0;
        background: #f3f3f4;

        &:hover {
            background: #d3d9e1;
        }

        &.selected {
            background: #909399;
        }
    }
}
</style>

<style lang="scss">
#snackbar {
    *:not(i) {
        font-family: Poppins;
    }

    &.v-snack--top {
        top: 15px;
    }

    .v-snack__wrapper {
        height: 40px;
        padding: 0 25px;

        &.success {
            background: var(--primary) !important;
        }

        .v-snack__content {
            color: white;
            font-size: 1rem;
        }

        .v-snack__action {
            cursor: pointer;
        }
    }

    &.free-plan-used, &.black-friday-deal, &.browser-notice, &.browser-crash-notice {
        top: 0;
        .v-snack__wrapper {
            border-radius: initial !important;
            width: 100%;
            max-width: initial;
            margin: 0;
        }

        .v-snack__content {
            text-align: center;
        }
    }

    &.black-friday-deal, &.browser-notice {
        .v-snack__wrapper {
            background-color: var(--primary) !important;
        }

        span {
            font-weight: bold;
        }
    }

    &.browser-crash-notice {
        span {
            font-weight: bold;
        }
    }
}

.--app #snackbar {
    *:not(i) {
        font-family: Poppins;
    }
}
</style>
